import { render, staticRenderFns } from "./discipline-amount-cell.vue?vue&type=template&id=bfc2a5c4&scoped=true&"
import script from "./discipline-amount-cell.vue?vue&type=script&lang=js&"
export * from "./discipline-amount-cell.vue?vue&type=script&lang=js&"
import style0 from "./discipline-amount-cell.vue?vue&type=style&index=0&id=bfc2a5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc2a5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc2a5c4')) {
      api.createRecord('bfc2a5c4', component.options)
    } else {
      api.reload('bfc2a5c4', component.options)
    }
    module.hot.accept("./discipline-amount-cell.vue?vue&type=template&id=bfc2a5c4&scoped=true&", function () {
      api.rerender('bfc2a5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/discipline-amount-cell.vue"
export default component.exports